import { ExportAllAgecStatsQueryParams, useExportAllAgecStats } from "~/gen/api"
import { downloadFile } from "~/utils/downloadFile"

export const useExportAGECStatsMutation = (
  params: ExportAllAgecStatsQueryParams
) =>
  useExportAllAgecStats(
    { groupByCollection: params.groupByCollection },
    {
      mutation: {
        onSuccess(data) {
          downloadFile(
            data.data,
            `agec-stats_${new Date().toJSON().slice(0, 10)}.csv`,
            "text/csv"
          )
        },
      },
    }
  )
